import { Route, Routes } from "react-router-dom";
import Layout from "../Layout/Layout";
import {routes} from "./Route";

const LayoutRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}> {/* Wrap all routes inside Layout */}
        {routes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}
      </Route>
    </Routes>
  );
};

export default LayoutRoutes;
